import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';

export const StyledButton = styled(Button)`
  border: 1px solid #aaa;
  font-size: 0.875rem;
  padding: 8px 12px;
  color: #333;
  font-weight: normal;
  background: linear-gradient(#fff, #eee);

  &:focus,
  &:hover,
  &:active {
    color: #000;
    background: #eee;
    border: 1px solid #999;
  }
`;
